import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuthProvider } from "../auth/hooks/AuthProvider";
import { motion, AnimatePresence } from "framer-motion";
import LoadingDots from "./LoadingDots";
import { useNavigate } from "react-router-dom";

const Portfolio = () => {
  const { t } = useTranslation();
  const [portfolioData, setPortfolioData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedPropertyUrl, setSelectedPropertyUrl] = useState(null);
  const navigate = useNavigate();
  const { user } = useAuthProvider();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        console.log("Fetching portfolio data for user:", user);
        const response = await fetch("/data", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: user.username }),
        });
        const data = await response.json();
        console.log("Portfolio data:", data);
        setPortfolioData(data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching portfolio data:", error);
        setIsLoading(false);
        navigate("/error");
      }
    };

    fetchData();
  }, [user]);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (selectedPropertyUrl) {
      window.open(selectedPropertyUrl, "_blank");
    }
  };

  const filterProperties = (properties) => {
    return properties.filter(
      (property) =>
        property.Name.trim() !== "" &&
        (property.Name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          (property.ChildProperties &&
            property.ChildProperties.length > 0 &&
            filterProperties(property.ChildProperties).length > 0))
    );
  };

  const renderProperties = (properties) => {
    const filteredProperties = filterProperties(properties);

    const sortedProperties = filteredProperties.sort((a, b) => {
      if (a.Portfolio && !b.Portfolio) {
        return 1;
      } else if (!a.Portfolio && b.Portfolio) {
        return -1;
      } else {
        return a.Name.localeCompare(b.Name);
      }
    });

    const handlePropertyClick = (property) => {
      if (property.Url) {
        setSelectedProperty(property);
        setSelectedPropertyUrl(property.Url);
      }
    };

    if (sortedProperties.length === 0) {
      return null;
    }

    return sortedProperties.map((property) => (
      <li
        key={property.Id}
        className={`cursor-pointer px-2 text-black rounded ${property.Portfolio ? "font-bold" : "font-normal"}`}
      >
        <span
          className={`w-full p-2 block rounded ${selectedProperty === property ? "bg-retta-light-blue" : ""}`}
          onClick={() => handlePropertyClick(property)}
        >
          {property.Name}
        </span>
        {property.ChildProperties && property.ChildProperties.length > 0 && (
          <ul>{renderProperties(property.ChildProperties)}</ul>
        )}
      </li>
    ));
  };

  return (
    <div className="relative place-items-center h-full">
      <p className="mx-auto text-retta-green mt-16 text-xl text-center max-w-[450px]">
        {t("please-select")}
      </p>
      <div className="max-w-[700px] m-auto md:px-4 py-10">
        <AnimatePresence>
          <motion.div
            style={{ overflow: "hidden" }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            {isLoading ? (
              <div className="flex justify-center">
                <LoadingDots color="#80FFB7" />
              </div>
            ) : (
              <form className="p-1" onSubmit={handleSubmit}>
                <input
                  className="text-black py-3 px-4 rounded w-full"
                  type="text"
                  placeholder={t("search-list")}
                  value={searchQuery}
                  onChange={handleSearch}
                />
                <div className="overflow-auto mt-4 max-h-[400px] bg-white rounded">
                  <ul className="p-2">
                    {renderProperties(portfolioData) || (
                      <p className="text-black p-2 font-bold ">
                        {t("no-results")}
                      </p>
                    )}
                  </ul>
                </div>
                <div className="text-center">
                  <button
                    className="text-2xl mt-4 py-2 px-6 w-[90%] rounded-full min-h-[58px] md:self-end bg-retta-light-blue
                    text-retta-dark-blue hover:bg-retta-hover-blue hover:text-retta-green"
                    type="submit"
                  >
                    {t("go-site")}
                  </button>
                </div>
              </form>
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Portfolio;
